const waitForElement = (selector, {
  andProperty,
  rootDocument = document,
  waitFor = 100,
  limit = 20,
  windowElement = window
} = {}) => new Promise((resolve, reject) => {
  let counter = 0;
  let ivId = null;
  ivId = windowElement.setInterval(() => {
    const elm = rootDocument == null ? void 0 : rootDocument.querySelector(selector);
    if (elm && (!andProperty || (elm == null ? void 0 : elm[andProperty]))) {
      if (ivId) windowElement.clearInterval(ivId);
      resolve(elm);
      return;
    }
    counter++;
    if (counter >= limit) {
      if (ivId) windowElement.clearInterval(ivId);
      reject(new Error(`Element for "${selector}" can't be found.`));
    }
  }, waitFor);
});
const launchBVRateDialog = async (productId, rating, rootDocument = document, windowElement = window) => {
  var _a;
  const bvSelector = '[data-bv-show="inpage_submission"]';
  const currentBVContainer = rootDocument.querySelector(bvSelector);
  (_a = currentBVContainer == null ? void 0 : currentBVContainer.parentNode) == null ? void 0 : _a.removeChild(currentBVContainer);
  const BVInstance = windowElement.BV || windowElement.$BV;
  BVInstance == null ? void 0 : BVInstance.ui("rr", "submit_review", {
    productId
  });
  const shadowHost = await waitForElement(bvSelector, {
    waitFor: 100,
    andProperty: "shadowRoot",
    rootDocument,
    windowElement
  });
  const elementToClick = await waitForElement(
    `[role="radiogroup"] > div:nth-child(${rating})`,
    {
      waitFor: 100,
      rootDocument: shadowHost.shadowRoot,
      windowElement
    }
  );
  elementToClick == null ? void 0 : elementToClick.click();
};
export {
  launchBVRateDialog,
  waitForElement
};
//# sourceMappingURL=bazaarVoiceUtils.mjs.map
